var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "59554A50-8B32-484F-9147-3A33075D7F3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A74E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6FE6",
    offset: "31.4717061%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D69EA",
    offset: "66.8206292%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-Icon",
    transform: "translate(-16.000000, -16.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6297321,28.3704419 C36.1103255,28.8511382 36.110242,29.6304174 35.6295457,30.1110108 C35.1488494,30.5916041 34.3695702,30.5915206 33.8889769,30.1108243 C31.5405052,27.7618495 27.7175444,27.7191409 25.3148816,29.9827867 L25.18288,30.1109176 L20.2555934,35.0382041 C17.8635169,37.430793 17.8635169,41.3518888 20.2555002,43.7438721 C22.6045666,46.0929385 26.4275382,46.1356488 28.8297161,43.872003 L28.9616903,43.7438721 L32.0035335,40.7020289 C32.4841783,40.2213841 33.2634575,40.2213841 33.7441023,40.7020289 C34.1994501,41.1573766 34.2234157,41.8807508 33.8159993,42.3643118 L33.7441023,42.4425977 L30.7023524,45.4843477 C27.3490892,48.8383292 21.8688197,48.8383292 18.5149314,45.4844409 C15.2132779,42.1827874 15.1624832,36.8197857 18.3625474,33.4540204 L18.5149314,33.2977285 L23.4423112,28.3703487 C26.7961994,25.0164604 32.276469,25.0164604 35.6297321,28.3704419 Z M45.4850754,18.5154046 C48.7867289,21.8170581 48.8375236,27.1800597 45.6374075,30.5458769 L45.4850211,30.7021713 L40.5570803,35.6294967 C37.2038229,38.9827541 31.7236252,38.9827541 28.3703678,35.6294967 C27.889723,35.1488519 27.889723,34.3695727 28.3703678,33.8889279 C28.8510127,33.4082831 29.6302919,33.4082831 30.1109367,33.8889279 C32.4594141,36.2374054 36.2824443,36.2801049 38.6845933,34.0169753 L38.8165658,33.8888736 L43.7444134,28.9616414 C46.1364899,26.5690524 46.1364899,22.6479567 43.7445066,20.2559734 C41.3954402,17.906907 37.5724686,17.8641967 35.1702907,20.1278425 L35.0383164,20.2559734 L31.9964733,23.2978166 C31.5158285,23.7784614 30.7365493,23.7784614 30.2559045,23.2978166 C29.8005567,22.8424688 29.7765911,22.1190947 30.1840074,21.6355337 L30.2559045,21.5572477 L33.2976544,18.5154978 C36.6509176,15.1615163 42.1311871,15.1615163 45.4850754,18.5154046 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.81bb44cb4b1f5d6cf9d2dee4356ed937.svg";
export { ForwardRef as ReactComponent };